export const loadScriptSize = ( modules = [], resolve ) => {

    let formData = new FormData()

    formData.append('action', 'sjsc')
    modules.forEach( module => {
        formData.append('modules[]', module)
    } )

    return fetch(
        document.location.href, 
        {
            method: "POST",
			mode: 'cors',
            body: formData
        }
    )
    .then( r => r.json() )
    .then( r =>  resolve(null, r))
    .catch(resolve)
}